import './Drawer.scss'

interface DrawerHeaderProps {
  children?: React.ReactNode
}

export const DrawerHeader: React.FC<DrawerHeaderProps> = ({ children }) => {
  return <div className="drawer-header">{children}</div>
}
